import {
  Box,
  Button,
  Grid,
  InputLabel,
  Paper,
  TextField,
  Typography,
  Container,
} from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import Navbar from "../../components/Navbar";
import { useForm, Controller } from "react-hook-form";
import ReactCodeInput from "react-code-input";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useSnackbar } from "notistack";
import { useDispatch } from "react-redux";
import Cookies from "js-cookie";
import { loginTeacher } from "../../redux/teacherSlice";
import { loginStudent } from "../../redux/studentSlice";
import { loginParent } from "../../redux/parentSlice";
import authIcon from "../../images/auth.png";
import moalimeIcon from "../../images/moalime.svg";

const PRIMARY_COLOR = "#3B82F6FC";

export default function SignIn() {
  const dispatch = useDispatch();
  const { closeSnackbar, enqueueSnackbar } = useSnackbar();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const inputRef = useRef();

  const [loading, setLoading] = useState(false);
  const [location, setLocation] = useState({ latitude: null, longitude: null });
  const [initialLoading, setInitialLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setInitialLoading(false);
    }, 1000); // 60 ثانية
  
    return () => clearTimeout(timer); // تنظيف التايمر لو خرج المستخدم قبل انتهاء الوقت
  }, []);
  const lang = Cookies.get("i18next") || "en";

  const {
    register,
    control,
    formState: { errors },
    handleSubmit,
  } = useForm({ defaultValues: { email: "" } });

  useEffect(() => {
    navigator.geolocation.getCurrentPosition(
      (pos) => {
        const { latitude, longitude } = pos.coords;
        setLocation({ latitude, longitude });
      },
      (err) => console.error("Location error:", err)
    );
  }, []);

  const onSubmit = async (data) => {
    setLoading(true);
    closeSnackbar();

    try {
      const response = await fetch(`${process.env.REACT_APP_API_KEY}api/v1/login`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          email: data.email,
          password: inputRef.current.state.value,
          lang,
          lat: location.latitude,
          long: location.longitude,
        }),
      });

      const resData = await response.json();

      if (response.status !== 200 && response.status !== 201) {
        enqueueSnackbar(resData.message, { variant: "error", autoHideDuration: 8000 });
        throw new Error("Login failed");
      }

      localStorage.clear();
      setLoading(false);

      switch (resData.role) {
        case "teacher":
          dispatch(loginTeacher({ token: resData.token, teacher: resData.data }));
          navigate("/teacher/about");
          break;
        case "student":
          dispatch(loginStudent({ token: resData.token, student: resData.data }));
          navigate("/");
          break;
        case "parent":
          dispatch(loginParent({ token: resData.token, parent: resData.data }));
          navigate("/parent");
          break;
        default:
          break;
      }
    } catch (err) {
      setLoading(false);
      console.error(err);
    }
  };
  if (initialLoading) {
    return (
      <Navbar>
              <Box
        sx={{
          display: "flex",
          height: "100vh",
          alignItems: "center",
          justifyContent: "center",
          backgroundColor: "#f5f5f5",
        }}
      >
        <Typography variant="h5" sx={{ color: PRIMARY_COLOR }}>
          جاري التحميل...
        </Typography>
      </Box>
      </Navbar>

    );
  }
  
  return (
    <Navbar>
      <Container sx={{ mt: 12, mb: 8 }}>
        <Paper
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "start",
            background: PRIMARY_COLOR,
            borderRadius: "23px",
            flexDirection: { xs: "column", md: "row" },
          }}
        >
          <Box
            sx={{
              width: "100%",
              padding: { md: 5, xs: 2 },
              backgroundColor: "#fff",
              borderRadius: "12px",
              boxShadow: "0px 2px 10px rgba(0, 0, 0, 0.1)",
              margin: { md: "auto 2rem", xs: 0 },
            }}
          >
            <form onSubmit={handleSubmit(onSubmit)}>
              <Box
                sx={{
                  border: `3px solid ${PRIMARY_COLOR}`,
                  borderRadius: "5px",
                  background: PRIMARY_COLOR,
                  p: 1,
                  mb: 3,
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <img src={moalimeIcon} alt="logo" width={150} />
              </Box>

              <Typography
                sx={{
                  fontSize: { md: "25px", xs: "20px" },
                  fontWeight: "700",
                  mb: 2,
                  color: PRIMARY_COLOR,
                  textAlign: "center",
                }}
              >
                {t("loginemail")}
              </Typography>

              <Box sx={{ mb: 4 }}>
                <InputLabel sx={{ fontWeight: 700, fontSize: "13px", color: PRIMARY_COLOR, mb: 1 }}>
                  {t("Email")}
                </InputLabel>
                <Controller
                  name="email"
                  control={control}
                  render={({ field }) => (
                    <TextField type="email" {...field} fullWidth />
                  )}
                  {...register("email", {
                    required: "email Address is required",
                  })}
                />
                {errors.email?.type === "required" && (
                  <Typography color="error" sx={{ fontSize: "13px", mt: 1 }}>
                    {t("required")}
                  </Typography>
                )}
              </Box>

              <InputLabel sx={{ fontWeight: 700, fontSize: "13px", color: PRIMARY_COLOR, mb: 1 }}>
                {t("password")}
              </InputLabel>
              <Box sx={{ px: {md:0,xs:5}, mb: 2 }}>
                <Box sx={{ direction: "rtl" }}>
                  <ReactCodeInput type="number" fields={4} ref={inputRef} />
                </Box>
              </Box>

              <Typography
                onClick={() => navigate("/forgetPassword/step1")}
                sx={{
                  mt: 3,
                  mb: 3,
                  fontSize: "15px",
                  fontWeight: "700",
                  color: "#D10909",
                  cursor: "pointer",
                  textAlign: "start",
                }}
              >
                {t("forgetpassword")}
              </Typography>

              <Button
                variant="contained"
                fullWidth
                type="submit"
                sx={{ textTransform: "capitalize", backgroundColor: PRIMARY_COLOR }}
              >
                {loading ? `${t("login")}...` : t("login")}
              </Button>

              <Typography
                sx={{
                  mt: 3,
                  mb: 2,
                  fontSize: "15px",
                  fontWeight: "700",
                  textAlign: "center",
                }}
              >
                {t("donthaveacount")}
              </Typography>

              <Grid container spacing={2}>
                {[
                  { label: "student", path: "/studentregister/step1" },
                  { label: "teacher", path: "/teacherRegister/step1" },
                  { label: "parent", path: "/parent/register" },
                ].map(({ label, path }) => (
                  <Grid item xs={4} key={label}>
                    <Button
                      fullWidth
                      variant="outlined"
                      onClick={() => navigate(path)}
                      sx={{ textTransform: "capitalize" }}
                    >
                      {t(label)}
                    </Button>
                  </Grid>
                ))}
              </Grid>
            </form>
          </Box>

          {/* Auth illustration image */}
          <Box sx={{ display: { md: "block", xs: "none" } }}>
            <img src={authIcon} alt="auth" width={1500}/>
          </Box>
        </Paper>
      </Container>
    </Navbar>
  );
}
